import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Categories", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Add Category ")
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Scenarios ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.newCategoriesMessage && !_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          closable: true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.newCategoriesMessage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createVNode(_component_DataTable, {
      value: _ctx.categories,
      "row-class": _ctx.handleRowClass
    }, {
      header: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "p-button",
          to: { name: _ctx.CategoryAddRoute }
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "title",
          header: "Title"
        }, {
          body: _withCtx((slotProps) => [
            (!_ctx.isAdmin && slotProps.data.newAddition)
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 0,
                  value: "NEW",
                  severity: "success"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(slotProps.data.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Actions",
          class: "actions-column"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "p-button",
                    to: _ctx.editRoute(slotProps.data.id)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!slotProps.data.enabled)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "p-button",
                          disabled: slotProps.data.loading,
                          onClick: ($event: any) => (_ctx.toggle(slotProps.data))
                        }, " Enable ", 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "p-button p-button-danger",
                          disabled: slotProps.data.loading,
                          onClick: ($event: any) => (_ctx.toggle(slotProps.data))
                        }, " Disable ", 8, _hoisted_6))
                  ], 64)),
              _createVNode(_component_router_link, {
                class: "p-button",
                to: _ctx.scenariosRoute(slotProps.data.id)
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "row-class"])
  ], 64))
}